import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'openingTime',
    standalone: false
})
export class OpeningTimePipe implements PipeTransform {
  transform(value: number, format: string): string {
    let str:string
    switch (format) {
      case 'en-US':
        if (value > 12) {
          str = (value - 12).toFixed(2) + ' pm'
        } else {
          str = value.toFixed(2) + ' am'
        }
        break;
      case 'de-DE':
        str = value.toFixed(2)
        break;
      default:
        str = 'oops'
        break;
    }
    return str.replace(".", ":")
  }

}
